import React from "react";

const OrganizationContext = React.createContext({
  organization: {},
  identifier: "",
  flags: {},
  serviceLocale: {},
});
OrganizationContext.displayName = "OrganizationContext";

function OrganizationProvider({ children }) {
  // Read organization data from the global set by the Rails layout.
  // Use the live window reference so dynamically updated flags (e.g. from
  // Cucumber step definitions) are picked up on re-render.
  const org = (window.UW211 && window.UW211.ORGANIZATION) || {};
  const value = React.useMemo(
    () => ({
      organization: org,
      identifier: org.uw211_identifier || "",
      flags: org.flags || {},
      serviceLocale: org.serviceLocale || {},
    }),
    [org]
  );

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
}

function useOrg() {
  return React.useContext(OrganizationContext);
}

export { OrganizationContext, OrganizationProvider, useOrg };
